import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'

export default class ShoppingCart extends Component {
    render() {
        return (
            <React.Fragment>
                {this.props.products.filter(f => f.isInCart === true).length === 0 && (
                    <div className="alert alert-info">
                        <div className="container">
                            <div className="content">
                                <p>Your cart is empty </p> <a href="/"><button>Go Shopping</button></a>
                            </div>
                        </div>
                    </div>
                )}
                {this.props.products.filter(f => f.isInCart ===true).length > 0 && (
                    <div className="cart">
                        <div className="container">
                            <div className="content">
                                {this.props.products.filter(f => f.isInCart === true).map(p => (
                                    <div className="product" key={p.id}>
                                        <div className="content">
                                            <div className="left">
                                                <div className="image">
                                                    <img src={p.imgUrl} alt={p.name} />
                                                </div>
                                            </div>
                                            <div className="name">
                                                <h4>{p.name}</h4>
                                            </div>
                                            <div className="con">
                                                <h6>Quantity</h6>
                                                <div className="items">
                                                    <div className="badge bg-success">{p.count}</div>
                                                    <button onClick={()=> this.props.onAdd(p)} className="btn btn-danger">+</button>
                                                </div>
                                            </div>
                                            <div className="con">
                                                <h5>SUBTOTAL</h5>
                                                <h3>${`${p.price * p.count}`}</h3>
                                            </div>
                                        </div>
                                        <button onClick={() => this.props.onDelete(p)} className='close btn btn-danger'><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                        </svg> </button>
                                    </div>
                                ))}
                                <div className="finish">
                                    <hr />
                                    <div className="buttons">
                                        <NavLink className="button" to='/'><button>CONTINUE SHOPPING</button></NavLink>
                                        <NavLink className="button" to='/address'><button onClick={() => this.props.onTotal()}>CHECK OUT</button></NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </React.Fragment>
        )
    }
}
